<template>
  <div
    class="status"
    id="tooltip-target-1"
    v-b-tooltip.hover
    :title="toTitleCase(type)"
    @click="handleChange"
    :class="getType()"
  >
   <StatusIndicator :type="type" styles="padding: 0" /> <div style="display: flex; align-items: center;">{{ toTitleCase(type) }}</div>
  </div>
</template>
<script>
import startCase from "lodash/startCase";
import StatusIndicator from "./status-indicator";
export default {
  name: "StatusBox",
  components: {StatusIndicator},
  props: {
    type: String,
    exact: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      default: ()=>{},
    },
  },

  data: () => ({
    allowedStatus: [
      "failed",
      "successful",
      "active",
      "inactive",
      "pending",
      "cancelled",
      "others",
      "pending_customer_approval",
      "settled",
    ],
  }),
  methods: {

     handleChange() {
       console.log("handleChange")
       if(this.onClick)this.onClick()
       },
    toTitleCase(value) {
      if(value) {
      let change =
        value.toLowerCase() === "active"
          ? "successful"
          : value.toLowerCase() === "inactvie"
          ? "failed"
          : value;
      if (this.exact) {
        change = value;
      }
      return startCase(change.toLowerCase());
      } else {
        return 'Other'
      }
    },

    getType() {
      if (this.isSuccessful) return 'success'
      if (this.isFailed) return 'failed'
      if (this.isPending) return 'pending'
      if (this.isProcessing) return 'processing'
      if (this.isCancelled) return 'cancelled'
      return 'unknown'
    },
  },
  computed: {
    isSuccessful() {
      return ["successful", "settled", "active"].includes(
        this.type ? this.type.toString().toLowerCase() : ''
      );
    },
    isFailed() {
      return ["inactive", "failed", "stop", "unsettled"].includes(
        this.type ? this.type.toString().toLowerCase() : ''
      );
    },
    isPending() {
      return ["pending", "pending_customer_approval", "stop"].includes(
        this.type ? this.type.toString().toLowerCase() : ''
      );
    },
    isProcessing() {
      return ['processing'].includes(
              this.type ? this.type.toString().toLowerCase() : ''
      );
    },
    isCancelled() {
      return ["cancelled", "stopped"].includes(
        this.type ? this.type.toString().toLowerCase(): ''
      );
    },
    isUnknown() {
      return ["unknown","other"].includes(this.type.toString().toLowerCase());
    },
  },
};
</script>
<style lang="scss" scoped>
.status {
  border-radius: 4px;
  padding: 10px 15px;
  margin-right: 7px;
  display: flex;
  span {
    color: transparent;
  }
  text-align: center;
  cursor: pointer;
}

.success, .settled {
  background: rgba(21, 206, 154, 0.05);
  border: 1px solid #15CE9A;
  box-sizing: border-box;
}

.pending, .batch_progress {
  background: rgba(233, 63, 102, 0.05);
  border: 1px solid #F8CF61;
  box-sizing: border-box;
}
.cancelled, .processing, .unknown {
  background: rgba(23, 160, 251, 0.1);
  border: 1px solid #17A0FB;
}
.failed {
  background: rgba(233, 63, 102, 0.05);
  border: 1px solid #E93F66;
  box-sizing: border-box;
}
</style>